export const NAVIGATION_ACTIONS = {
    logout: 'logout',
    search: 'search',
    help: 'help',
    feedback: 'feedback',
    last_changes: 'last_changes',
}
